import React, {useRef, useState, useEffect } from 'react'
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import Chartjs from "chart.js";
const App16 = () => {
    const [loading, setLoading] = useState(true)
    const [items, setItems] = useState([])
    const [query, setQuery] = useState('Javascript React')
    const [data, setData] = useState([])
    const [labels, setLabels] = useState([])
    const [prices, setPrices] = useState([])
    const [base, setBase] = useState('')
    const [date, setDate] = useState()
        useEffect(() => {
        fetch("https://api.exchangeratesapi.io/latest") 
        .then(res => res.json()) 
        .then(json => {
          console.log(json.rates);
          setBase(json.base)
          setDate(json.date)
          setLoading(false);
          setItems(json.rates);
        });
    }, [])

    useEffect(() => {
        if(Object.keys(items).length)
        for(let key in items){
            if(key !== 'IDR' && key !== 'KRW'){
                labels.push(key)
                prices.push(items[key])
            }
        }
        console.log(labels)
    }, [items])
    const getQiitaPosts = () => {
        axios.get('https://qiita.com/api/v2/items', {
            params: {
              "page": "1",
              "per_page": "20",
              "query": query,
            }
          })
          .then((response) => {
            const data = response.data;
            setData(data)
            console.log("ressponse: " + response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
      const search = (e) =>{
          setQuery(e.target.value)
      }

      const chartRef = useRef();
      useEffect(() => {
        if (chartRef && chartRef.current && items) {
          const chartInstance = new Chartjs(chartRef.current, {
            type: "line",
            data: {
                labels: labels,
                datasets: [
                  {
                    label: 'price',
                    data: prices,
                    borderColor: "rgba(255,0,0,1)",
                    backgroundColor: "rgba(0,0,0,0)"
                  },
                ],
              },
              options: {
                title: {
                  display: true,
                  text: 'Base Currency: ' + base + ' Date: ' + date
                },}
          });
        }
      });

  return (
    <div style={{backgroundColor:'white'}}>
        <h1>https://exchangeratesapi.io/より取得</h1>
        <canvas ref={chartRef}  id="myChart"></canvas>
     {/* {loading? <div>Loading...</div>:<div>
          <ul>
            {Object.keys(items).map(key => (
              <li key={key}>{key} - {items[key]}</li>
            ))}
          </ul>
        </div>} */}

        <TextField id="standard-basic" label="Qiitaの記事を検索します^^" value={query} onChange={(e)=>search(e)}/>
        <input
              type="button"
              value="検索"
              onClick={() => getQiitaPosts()}
            />
        {data.length > 0? data.map((d, i)=>{
            return(<div className="App" key={i}>
            <h1 className="app-title">Hello Qiita API</h1>
            <p>タイトル: {d.title}</p>
            <p>URL: <a target="__blank" href={d.url}>{d.url}</a></p>
            
          </div>)

                }):''}
        
    </div>
  )
}

export default App16
